import { motion, useReducedMotion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

export default function Portada({ datos }) {
  const { pareja, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 18 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="cv-portada" data-testid="cv-portada">
      <div className="cv-portada-texto">
        <motion.p className="cv-portada-frase" {...entrar(0.1)}>
          {pareja.fraseIntroductoria}
        </motion.p>
        <motion.h1 className="cv-portada-nombres" {...entrar(0.25)}>
          <span data-testid="cv-nombre-1">{pareja.nombre1}</span>
          <span className="cv-portada-y">&</span>
          <span data-testid="cv-nombre-2">{pareja.nombre2}</span>
        </motion.h1>
        <motion.p className="cv-portada-fecha" data-testid="cv-fecha" {...entrar(0.4)}>
          {evento.fechaLegible}
          <span className="cv-portada-ciudad">{evento.ciudad}</span>
        </motion.p>
        <motion.p className="cv-portada-mensaje" {...entrar(0.55)}>
          {pareja.mensajePortada}
        </motion.p>
        <motion.a
          href="#cv-contenido"
          className="cv-portada-bajar"
          aria-label="Desplazarse al contenido de la invitación"
          data-testid="cv-boton-bajar"
          {...entrar(0.7)}
        >
          <ArrowDown size={16} strokeWidth={1.5} />
        </motion.a>
      </div>
      <motion.div className="cv-portada-marco" {...entrar(0.6)}>
        {datos.portadaVideo?.urlYoutube ? (
          <FondoVideoAmbient
            urlYoutube={datos.portadaVideo.urlYoutube}
            poster={datos.portadaVideo.poster || fotos.portada}
          />
        ) : (
          <img
            className="cv-portada-foto"
            src={fotos.portada}
            alt={`Fotografía de ${pareja.nombre1} y ${pareja.nombre2}`}
          />
        )}
      </motion.div>
    </header>
  );
}
